<ng-container>
	<!--
	<code>
		<pre>
			{{ vendor_data | json }}
		</pre>
	</code>
	-->
	<div class="row mt-2 mb-1">
		<div class="col-md-4 text-center">
			<small class="text-muted">Terms</small><br>{{ vendor_data.terms }}
		</div>
		<div class="col-md-4 text-center">
			<small class="text-muted">Tax Group</small><br>{{ vendor_data.taxgroupdescription }}
		</div>
	</div>

	<form [formGroup]="invoiceForm" *ngIf="invoiceForm" (keydown.enter)="onEnterKeyDown($event)" class="vendor-credit-form no-overflow">
		<ng-template matStepLabel>Credit Information</ng-template>
		<div class="vendor-credit-form__section">
			<div class="row vendor-credit-form__row">
				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline" class="vendor-credit-field">
						<mat-label>Reference</mat-label>
						<input matInput required value="" formControlName="reference" (keyup)="onReferenceBlur()">
						<mat-error *ngIf="invoiceForm.get('reference')?.hasError('referenceUsed')">Credit reference already used for this vendor</mat-error>
						<mat-error *ngIf="invoiceForm.get('reference')?.invalid && invoiceForm.get('reference')?.errors?.required && invoiceForm.get('reference')?.touched">Reference is required</mat-error>
					</mat-form-field>
				</div>
				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline" class="vendor-credit-field">
						<mat-label>Department</mat-label>
						<mat-select formControlName="tag">
							<mat-option [value]="null">— None —</mat-option>
							<mat-option *ngFor="let tag of glTags" [value]="tag">{{ tag.description }}</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-12 col-md-2">
					<mat-form-field appearance="outline" class="vendor-credit-field">
						<mat-label>Credit Date</mat-label>
						<input matInput [matDatepicker]="invoiceDate" formControlName="invoiceDate">
						<mat-datepicker-toggle matSuffix [for]="invoiceDate"></mat-datepicker-toggle>
						<mat-datepicker #invoiceDate></mat-datepicker>
					</mat-form-field>
				</div>
				<div class="col-12 col-md-2">
					<mat-form-field appearance="outline" class="vendor-credit-field">
						<mat-label>Currency</mat-label>
						<mat-select formControlName="currcode">
							<mat-option *ngFor="let cur of currencies" [value]="cur.currabrev">{{ cur.currabrev }} – {{ cur.currency }}</mat-option>
						</mat-select>
					</mat-form-field>
				</div>
				<div class="col-12 col-md-2">
					<mat-form-field appearance="outline" class="vendor-credit-field">
						<mat-label>Exchange Rate</mat-label>
						<input matInput required formControlName="rate" placeholder="e.g. 100" appSelectOnFocus>
						<mat-hint>100 = 1:1</mat-hint>
					</mat-form-field>
				</div>
			</div>
			<div class="row vendor-credit-form__row">
				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline" class="vendor-credit-field">
						<mat-label>Due Date</mat-label>
						<input matInput [matDatepicker]="dueDatePicker" formControlName="dueDate">
						<mat-datepicker-toggle matSuffix [for]="dueDatePicker"></mat-datepicker-toggle>
						<mat-datepicker #dueDatePicker></mat-datepicker>
					</mat-form-field>
				</div>
				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline" class="vendor-credit-field">
						<mat-label>Discount Date</mat-label>
						<input matInput [matDatepicker]="discountDate" formControlName="discountDate">
						<mat-datepicker-toggle matSuffix [for]="discountDate"></mat-datepicker-toggle>
						<mat-datepicker #discountDate></mat-datepicker>
					</mat-form-field>
				</div>
				<div class="col-12 col-md-3">
					<mat-form-field appearance="outline" class="vendor-credit-field vendor-credit-field--amount">
						<mat-label>Discount Amount</mat-label>
						<span matPrefix>$</span>
						<input matInput formControlName="discountAmount" (input)="setDiscount($event)">
					</mat-form-field>
				</div>
				<div class="col-12 col-md-3 d-flex align-items-center">
					<button mat-raised-button color="accent" (click)="openNoRGAItemsModal()" class="vendor-credit-form__no-rga-btn">
						<mat-icon>inventory</mat-icon>
						NO RGA Items
					</button>
				</div>
			</div>
		</div>
		<div class="vendor-credit-form__section vendor-credit-form__section--grn-gl">
			<div class="row vendor-credit-form__row align-items-end">
				<div class="col-md-6">
					<div class="vendor-credit-form__grn-row">

						<mat-form-field appearance="outline" class="vendor-credit-field vendor-credit-field--grn">
							<mat-label>GRN's</mat-label>
							<mat-chip-list #grnList aria-label="Selected Pos">
								<mat-chip *ngFor="let grn of selected_grnbatches" (removed)="remove(grn)">
									GRN#: {{ grn.grnbatch }} RGA#:{{grn.orderno}}
									<button matChipRemove>
										<mat-icon>cancel</mat-icon>
									</button>
								</mat-chip>
								<input type="text" #grnInput placeholder="Select Purchase Order" [matChipInputFor]="grnList" matInput [matChipInputSeparatorKeyCodes]="separatorKeysCodes" (matChipInputTokenEnd)="add($event)" formControlName="grns" [matAutocomplete]="auto">
							</mat-chip-list>
							<mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)" [displayWith]="displayGrn">
								<mat-option *ngFor="let grn of filteredGrnBatches()" [value]="grn">
									GRN#: {{ grn.grnbatch }} RGA#:{{grn.orderno}} {{ grn.grnno }} {{ grn.itemcode || '' }}
								</mat-option>
							</mat-autocomplete>
						</mat-form-field>
					</div>
				</div>
				<div class="col-md-6">
					<app-gl-account-lookup (glselected)="addGl($event)"></app-gl-account-lookup>
				</div>
			</div>
		</div>
		<div class="vendor-credit-form__section">
			<div class="row">
				<div class="col-12">
				<table class="table table-sm" *ngIf="selected_grns.length || glcharges.length">
					<tr>
						<th>Item</th>
						<th>Desc</th>
						<th matTooltip="Received qty / PO ordered qty">Recvd / Ord</th>
						<th class="text-center" matTooltip="Qty already invoiced on prior vendor invoices / qty received on this GRN line">Invcd / Recd</th>
						<th>PO Price</th>
						<th>Invoice#</th>
						<th>Invoice Price</th>
						<th class="text-right" *ngIf="config?.env?.package == 'tires'">FET</th>
						<th class="text-right">{{ config?.env?.package == 'tires' ? 'Line Subtotal' : 'Line Total' }}</th>
						<th class="text-right"></th>
					</tr>
					<tr *ngFor="let grn of selected_grns">
						<td class="pt-4">{{ grn.itemcode }}</td>
						<td class="pt-4">
							{{ grn.itemdescription }}
							<mat-form-field appearance="outline" subscriptSizing="dynamic" class="vendor-line-dept text-left mt-2" *ngIf="glTags?.length">
								<mat-label>Department</mat-label>
								<mat-select [value]="grn.tag ?? null" (selectionChange)="setGrnDept($event, grn)">
									<mat-option [value]="null">— Header default —</mat-option>
									<mat-option *ngFor="let tag of glTags" [value]="tag">{{ tag.description }}</mat-option>
								</mat-select>
							</mat-form-field>
						</td>
						<td class="pt-4 text-center">
							<span class="vendor-qty-pill" [ngClass]="vendorRecvdOrdPillClass(grn)" matTooltip="Received / PO ordered">{{ grn.qtyrecd }} / {{ grn.quantityord }}</span>
						</td>
						<td class="pt-4 text-center">
							<span class="vendor-qty-pill" [ngClass]="vendorInvcdRecdPillClass(grn)" matTooltip="Already invoiced / received">{{ (+grn.quantityinv || 0) }} / {{ (+grn.qtyrecd || 0) }}</span>
						</td>
						<td class="pt-4">{{ (grn.poUnitPrice != null && grn.poUnitPrice !== '' ? grn.poUnitPrice : grn.unitprice) | currency}}</td>
						<td>
							<mat-form-field appearance="outline" class="text-center col-10">
								<mat-label>Credit Qty.</mat-label>
								<input matInput required [(value)]="grn.toinvoice" (input)="setQty($event, grn)" appSelectOnFocus>
							</mat-form-field>
						</td>
						<td class="text-right align-top vendor-invoice-price-cell">
							<div class="vendor-price-field-shell"
								[ngClass]="{
									'vendor-price-field-shell--warn': invoicePriceDiffersFromPo(grn),
									'vendor-price-field-shell--ok': invoicePriceMatchesPo(grn)
								}"
								[matTooltip]="invoicePriceDiffersFromPo(grn) ? invoicePricePoDiffTooltip(grn) : invoicePriceMatchTooltip(grn)"
								[matTooltipDisabled]="!invoicePriceDiffersFromPo(grn) && !invoicePriceMatchesPo(grn)">
								<mat-form-field appearance="outline" class="vendor-price-mat-field text-left col-10" subscriptSizing="dynamic">
									<span matPrefix>$</span>
									<mat-label>Credit Price</mat-label>
									<input matInput required [(value)]="grn.unitprice" (input)="setPrice($event, grn)" moneyPipe appSelectOnFocus>
									<mat-hint *ngIf="invoicePriceMatchesPo(grn)" class="vendor-price-hint vendor-price-hint--ok">Matches PO</mat-hint>
									<mat-hint *ngIf="invoicePriceDiffersFromPo(grn)" class="vendor-price-hint vendor-price-hint--warn">Differs from PO</mat-hint>
								</mat-form-field>
							</div>
						</td>
						<td class="pt-4 text-right" *ngIf="config?.env?.package == 'tires'">
							{{ ((grn.fetcharge || 0) * (grn.toinvoice || 0)) | currency}}
						</td>
						<td class="pt-4">
							<b> {{ ((grn.unitprice || 0) * (grn.toinvoice || 0)) | currency}}</b>
						</td>
						<td class="pt-4">
							x <button mat-flat-button (click)="removeLine(grn)">
								<i class="material-icons">remove</i>
							</button>
						</td>
					</tr>
					<tr *ngFor="let gl of glcharges">
						<td class="pt-4">{{ gl.account }}</td>
						<td class="pt-4">
							{{ gl.name }}
							<mat-form-field appearance="outline" subscriptSizing="dynamic" class="vendor-line-dept text-left mt-2" *ngIf="glTags?.length">
								<mat-label>Department</mat-label>
								<mat-select [value]="gl.tag ?? null" (selectionChange)="setGlDept($event, gl)">
									<mat-option [value]="null">— Header default —</mat-option>
									<mat-option *ngFor="let tag of glTags" [value]="tag">{{ tag.description }}</mat-option>
								</mat-select>
							</mat-form-field>
						</td>
						<td></td>
						<td></td>
						<td></td>
						<td>
							<mat-form-field appearance="outline" class="text-left col-10">
								<span matPrefix>$</span>
								<mat-label>Price</mat-label>
								<input matInput required [(value)]="gl.value" (input)="setGlPrice($event, gl)" moneyPipe appSelectOnFocus>
							</mat-form-field>
						</td>
						<td class="pt-4 text-right">
							<b> {{ gl.value * gl.quantity | currency}}</b>
						</td>
						<td class="pt-4 text-right">
							<button mat-flat-button (click)="removeGl(gl)">
								<i class="material-icons">remove</i>
							</button>
						</td>
					</tr>
				</table>
				<div class="row">
					<div class="col-12 text-right" *ngIf="selected_grns.length || glcharges.length">
						<h5>{{ config?.env?.package == 'tires' ? 'Subtotal (before FET)' : 'Sub-Total' }}: {{ invoiceTotal | currency }}</h5>
						<ng-container>
							<div class="ml-auto text-right" *ngFor="let tax of vendor_data.taxes">
								<mat-form-field appearance="fill" class="ml-auto col-2 text-right">
									<span matPrefix>$</span>
									<mat-label>{{ tax.description }}</mat-label>
									<input matInput required value="{{tax.taxamount | number:'1.2-2'}}" (input)="setTaxValue($event, tax)" appSelectOnFocus>
								</mat-form-field>
							</div>
						</ng-container>
						<div class="row">
							<div class="col-md-12">
								<h5 class="mr-4">Tax: {{ taxTotal | currency }}</h5>
								<h5 class="mr-4" *ngIf="config?.env?.package == 'tires' && fetTotal > 0">FET Total: {{ fetTotal | currency }}</h5>
								<h5 class="mr-4">Discount: {{ discount | currency }}</h5>
								<h5 class="mr-4">Total: {{ totalTotal | currency }}</h5>
								<button mat-stroked-button type="button" color="primary" class="mr-2" (click)="openGlPreview()">Preview GL</button>
								<button mat-raised-button [color]="invoiceForm.valid ? 'primary' : 'accent'" (click)="onSubmit()">Create Credit</button>
							</div>
						</div>
					</div>
				</div>
				</div>
			</div>
		</div>
		<!-- Documents & Uploads: attachments + bulk CSV/Excel — grouped, collapsed by default -->
		<mat-expansion-panel class="vendor-documents-panel mt-4">
			<mat-expansion-panel-header>
				<mat-panel-title><mat-icon>folder_open</mat-icon> Documents &amp; Uploads</mat-panel-title>
				<mat-panel-description>Attach files or bulk-upload credits</mat-panel-description>
			</mat-expansion-panel-header>
			<div class="row vendor-documents">
				<div class="col-12 col-lg-6 vendor-documents__col">
					<span class="vendor-documents__label">Attachments <small>&mdash; PDF, images, Word, Excel</small></span>
					<ngx-dropzone (change)="onAttachmentSelect($event)" class="vendor-dropzone">
						<ngx-dropzone-label><mat-icon>attach_file</mat-icon><span>Drop or click to attach</span></ngx-dropzone-label>
						<ngx-dropzone-preview *ngFor="let f of attachmentFiles" [removable]="true" (removed)="onAttachmentRemove(f)">
							<ngx-dropzone-label>{{ f.name }} ({{ f.type }})</ngx-dropzone-label>
						</ngx-dropzone-preview>
					</ngx-dropzone>
				</div>
				<div class="col-12 vendor-documents__col vendor-documents__col--full">
					<span class="vendor-documents__label">Bulk Upload <small>&mdash; CSV/Excel, many credits</small></span>
					<app-vendor-credit-upload [vendor]="vendor_data" (newvendordata)="newvendordata.emit($event)" class="w-100"></app-vendor-credit-upload>
				</div>
			</div>
		</mat-expansion-panel>
	</form>
	<div class="text-center bold" *ngIf="!selected_grns.length  && !glcharges.length">
		Add Purchase Orders And/Or GL Charges
	</div>
</ng-container>
